import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { EnumValueLabelPipe, HorizontalListData, HorizontalListFactory, OfferBundleStatus, OfferBundleStatusLabel } from "common";
import { SalesforceUrlPipe } from "../../../../shared/pipes/salesforce-url.pipe";
import { OfferBundleDetailsData } from "./models/offer-bundle-details-data.model";

@Injectable()
export class OfferBundleDetailsAdapter {
  constructor(
    private readonly enumValueLabelPipe: EnumValueLabelPipe,
    private readonly datePipe: DatePipe,
    private readonly salesforceUrlPipe: SalesforceUrlPipe,
  ) { }

  adaptStatusListWidgetData = (data: OfferBundleDetailsData): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Status',
        displayedValue: this.enumValueLabelPipe.transform(data?.offerBundle?.status, OfferBundleStatus, OfferBundleStatusLabel)
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Updated on',
        displayedValue: this.datePipe.transform(data?.offerBundle?.updatedOn) || '-'
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Express checkout',
        displayedValue: data?.offerBundle?.expressCheckout ? 'Yes' : 'No',
      }),
      HorizontalListFactory.createKeyValueExternalLinkItem({
        title: 'Salesforce ID',
        displayedValue: data?.offerBundle?.uniqueId,
        externalLink: this.salesforceUrlPipe.transform(data?.offerBundle?.uniqueId),
        isValueHidden: !data?.offerBundle?.uniqueId
      }),
    ]
  }

  adaptApplicationListWidgetData = (data: OfferBundleDetailsData): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueRouterLinkItem({
        title: 'Application name',
        displayedValue: data?.application?.entityName,
        routerLink: `/application/${data?.application?.id}/profile`
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Application number',
        displayedValue: data?.application?.applicationNumber
      }),
      HorizontalListFactory.createKeyValueExternalLinkItem({
        title: 'Salesforce Application ID',
        displayedValue: data?.application?.uniqueId,
        externalLink: this.salesforceUrlPipe.transform(data?.application?.uniqueId),
        isValueHidden: !data?.application?.uniqueId
      }),
    ]
  }
}